<section>
  <div class="container-one">
    <div class="curve top-left-curve"></div>

    <div class="number">
      <img src="/auth/number-two.png" alt="number one image">
    </div>

  </div>

  <div class="container-two">
    <div class="content">
      <h3>Academic Year</h3>

      <p>Set the active academic calendar standards and visual theme colors.</p>

      <form #academicYearForm="ngForm" (ngSubmit)="createAcademicYear(academicYearForm)">
        <div>
          <label for="academicYearName">Academic Year</label>
          <input required [(ngModel)]="academicYearName" type="text" name="academicYearName" id="academicYearName" placeholder="eg. 2026/2027">
        </div>

        <div class="form-group">
          <div>
            <label for="startDate">Start Date</label>
            <input required [(ngModel)]="startDate" type="date" name="startDate" id="startDate">
          </div>

          <div>
            <label for="endDate">End Date</label>
            <input required [(ngModel)]="endDate" type="date" name="endDate" id="endDate">
          </div>
        </div>

        <div class="checkbox">
          <input [(ngModel)]="currentAcademicYear" type="checkbox" name="currentAcademicYear" id="currentAcademicYear">
          <label for="currentAcademicYear">Set as current academic year</label>
        </div>

        <div class="foot">
          <button routerLink="/school-onboarding/school-profile" class="button back-button" type="button"><img src="/auth/back-arrow.png" alt="back arrow"> Back</button>

          <button class="button" [disabled]="academicYearForm.invalid">
            @if (isLoading()) {
              <app-loading-indicator></app-loading-indicator>
            } @else {
              Next
            }
          </button>
        </div>

      </form>


    </div>
  </div>

  <div class="curve bottom-right-curve"></div>

</section>
